<div class="grid mt-4 px-3 align-items-center">
    <div class="flex justify-content-between w-full">
        <h6 class="m-0 small-heading">Invoices</h6>
        <span class="view-details" (click)="openInvoicePopup()">
            View Details <i class="pi pi-angle-right fs-6"></i>
        </span>
    </div>
</div>
<div class="px-3" *ngFor="let inv of visibleInvoices">
    <div class="invoice-card my-3">
        <div class="invoice-left">
            <span class="label">Invoice No.</span>
            <span class="value">#{{ inv.inv_no }}</span>
            <div class="due-row">
                <i class="pi pi-clock text-warning mr-2"></i>
                <span class="label">Due</span>
                <span class="due-date">{{ inv.due_date }}</span>
            </div>
        </div>
        <div class="invoice-right">
            <!-- READ MODE -->
            <span *ngIf="!inv.editing" class="amount">₹ {{ inv.amount }}</span>
            <!-- EDIT MODE -->
            <input *ngIf="inv.editing" type="text" [(ngModel)]="inv.amount" class="amount-input"  pTooltip="The payable amount can only be reduced (via credits or advances)"
                    tooltipPosition="left"/>
            <!-- ICONS -->
            <div class="action-icons flex align-items-center justify-content-end gap-2" *ngIf="!isListView && takeAction">
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="icon-edit custom-iconc"
                    class="p-button-rounded p-button-text p-button-plain"
                    *ngIf="!inv.editing"
                    (click)="inv.editing = true">
                </button>
                <i *ngIf="inv.editing"
                    class="pi pi-check text-success action-icon font-bold"
                    (click)="saveField(inv)">
                </i>
                <i
                    class="pi pi-times-circle text-danger action-icon ml-1"
                    (click)="deleteInvoice(inv)"
                    pTooltip="Remove invoice from payment list"
                    tooltipPosition="bottom">
                </i>
            </div>
        </div>
    </div>
</div>
<div class="grid text-center" *ngIf="invoiceList?.length > maxVisible">
    <p class="text-primary text-decoration-underline pointer" (click)="toggleInvoices()">
        {{ showAllInvoices ? 'See Less' : 'See More' }}
    </p>
</div>
<div class="grid mt-2 px-3 align-items-center">
    <div class="flex justify-content-between w-full">
        <h6 class="m-0 small-heading">Advances</h6>
    </div>
</div>
<div class="px-3">
    <div *ngFor="let adv of visibleAdvances" class="invoice-card my-3">
        <div class="invoice-left">
            <span class="label">Advance Reference No.</span>
            <div class="due-row">
                <span class="value">#{{ adv.advance_no }}</span>
            </div>
        </div>
        <div class="invoice-right">
            <span class="amount">₹ {{ adv.amount }}</span>
        </div>
    </div>
</div>
<div class="grid mb-2 text-center" *ngIf="advanceList?.length > maxVisible">
    <p class="text-primary text-decoration-underline pointer" (click)="toggleAdvances()">
        {{ showAllAdvances ? 'See Less' : 'See More' }}
    </p>
</div>